import http from '../../services/httpService';

export const listNotifications = (params) =>
  http.get('/notifications', { params }).then((r) => (r.data && r.data.data) || []);

export const unreadCount = () =>
  http.get('/notifications/unread-count').then((r) => {
    const data = r.data && r.data.data;
    return data && data.count != null ? data.count : 0;
  });

export const markRead = (ids) => http.post('/notifications/read', { ids });

export const markReadAll = () => http.post('/notifications/read-all');

export const dismissNotification = (id) => http.post(`/notifications/${id}/dismiss`);

export const dismissReadNotifications = () => http.post('/notifications/dismiss-read');

export const archiveNotification = (id) => http.post(`/notifications/${id}/archive`);

export const getPreferences = () =>
  http.get('/notification-preferences').then((r) => (r.data && r.data.data) || []);

export const putPreferences = (items) =>
  http.put('/notification-preferences', { items }).then((r) => (r.data && r.data.data) || []);
